"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PurposeAddendum_1 = __importDefault(require("./PurposeAddendum"));
exports.PurposeAddendum = PurposeAddendum_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9iZWxsdXMvRW5yb2xsbWVudEFncmVlbWVudC9wYXJ0cy9TZWN0aW9uMS9QdXJwb3NlQWRkZW5kdW0vaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxzRUFBK0M7QUFFdkMsMEJBRkQseUJBQWUsQ0FFQyJ9